import ApiService from "@/core/services/api.service";

export const FETCH_MECHANIC_HOURS = "fetchMechanicHours";
export const FETCH_MECHANIC_HOUR_TYPES = "fetchMechanicHourTypes";
export const STORE_BULK_MECHANIC_HOURS = "storeBulkMechanicHours";
export const DELETE_BULK_MECHANIC_HOURS = "deleteBulkMechanicHours";
export const SET_LOADING = "setLoadingMechanicHours";

const state = {
  isLoadingMechanicHours: false
};

const getters = {
  isLoadingMechanicHours() {
    return state.isLoadingMechanicHours;
  }
};

const actions = {
  [FETCH_MECHANIC_HOURS](context, apiParams = "") {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.get("mechanic-hours" + apiParams)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [FETCH_MECHANIC_HOUR_TYPES]() {
    return new Promise((resolve, reject) => {
      ApiService.get("mechanic-hour-types/options")
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        });
    });
  },
  [STORE_BULK_MECHANIC_HOURS](context, payload) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.post("mechanic-hours/bulk-store", payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  },
  [DELETE_BULK_MECHANIC_HOURS](context, payload) {
    context.commit(SET_LOADING, true);

    return new Promise((resolve, reject) => {
      ApiService.post("mechanic-hours/bulk-delete", payload)
        .then(({ data }) => {
          resolve(data);
        })
        .catch(({ response }) => {
          reject(response);
        })
        .finally(() => {
          context.commit(SET_LOADING, false);
        });
    });
  }
};

const mutations = {
  [SET_LOADING](state, value) {
    state.isLoadingMechanicHours = value;
  }
};

export default {
  state,
  actions,
  mutations,
  getters
};
